import { useThemeContext } from "../../../../context/ThemeContext";

const NavigationButtons = ({
  onBack,
  onNext,
  backLabel = "Back",
  nextLabel = "Next",
  showBack = true,
  nextDisabled = false,
}) => {
  const { darkMode } = useThemeContext();

  return (
    <div className="flex justify-between mt-6">
      {showBack && (
        <button
          className={`px-4 py-2 rounded-lg font-medium ${
            darkMode
              ? "bg-[#252525] text-white hover:bg-[#383838]"
              : "bg-gray-200 text-gray-700 hover:bg-gray-300"
          } transition-colors`}
          onClick={onBack}
        >
          {backLabel}
        </button>
      )}
      <button
        className={`px-4 py-2 rounded-lg font-medium ${
          darkMode
            ? nextDisabled
              ? "bg-[#383838] text-gray-500 cursor-not-allowed"
              : "bg-[#A41E22] hover:bg-[#8A1A1E] text-white"
            : nextDisabled
              ? "bg-gray-300 text-gray-500 cursor-not-allowed"
              : "bg-[#A41E22] hover:bg-[#8A1A1E] text-white"
        } transition-colors`}
        onClick={onNext}
        disabled={nextDisabled}
      >
        {nextLabel}
      </button>
    </div>
  );
};

export default NavigationButtons;
